<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="区域" prop="organizationName">
              <el-input
                v-model="searchForm.organizationName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商" prop="customerName">
              <el-input
                v-model="searchForm.customerName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商经营状态" prop="businessStatus">
              <el-select v-model="searchForm.businessStatus" clearable @change="onSearch">
                <el-option v-for="item in businessStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提现人" prop="userName">
              <el-input
                v-model="searchForm.userName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="提现人状态" prop="userStatus">
              <el-select v-model="searchForm.userStatus" clearable @change="onSearch">
                <el-option v-for="item in userStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="钱包类型" prop="walletType">
              <el-select v-model="searchForm.walletType" clearable @change="onSearch">
                <el-option v-for="item in walletTypeStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="银联商户号" prop="mchNo">
              <el-input
                v-model="searchForm.mchNo"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item> -->
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">导出</el-button>
          <el-button type="primary" size="small" @click="isTransferPop = true">转账</el-button>
          <el-button type="primary" size="small" @click="jumpTransferRecord">转账记录</el-button>
          <el-button type="primary" size="small" v-permission="`activity-pc-manage-api-new#adjust`" @click="isShowAdjustDialog = true">调账</el-button>
          <el-button type="primary" size="small"  @click="jumpAdjustRecord">调账记录</el-button>
        </template>
        <template v-slot:header-right>
          <el-button type="primary" size="small" v-permission="`activity-pc-manage-api-new#walletImport`" @click="isShowImportDialog = true">导入</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="organizationName" label="区域" align="center"  width="160"></el-table-column>
          <el-table-column prop="customerName" label="经销商" align="center" show-overflow-tooltip width="300"></el-table-column>
          <el-table-column prop="cusCode" label="经销商编码" align="center" show-overflow-tooltip min-width="120"></el-table-column>
          <el-table-column prop="mchNo" label="银联商户号" align="center" show-overflow-tooltip min-width="120"></el-table-column>
          <el-table-column label="经销商经营状态" align="center" min-width="120">
            <template slot-scope="scope" >
              <span>{{scope.row.businessStatus | businessStatus}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="提现人" align="center"  min-width="120"></el-table-column>
          <el-table-column label="提现人状态" align="center" prop="userStatusExcel" min-width="120"></el-table-column>
          <el-table-column label="钱包类型" align="center" prop="walletType" min-width="120">
            <template slot-scope="scope" >
              <span>{{scope.row.walletTypeString}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="balanceAmount" label="钱包余额(元)" align="center" min-width="120">
            <template slot="header">
              <el-tooltip effect="dark" content="不包含“退款冻结金额”" placement="top-start">
                <span>钱包余额(元)<i class="el-icon-question"></i></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="freezeAmount" label="退款冻结金额" align="center" min-width="120"></el-table-column>
          <el-table-column label="操作" class-name="action-column" fixed="right" align="center" width="120">
            <template v-slot="scope">
              <el-button type="text" size="small" v-if="scope.row.walletType == 9" @click="look(scope.row)">查看银联冻结保证金</el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <transfer-pop :isTransferPop.sync="isTransferPop"/>
    <wallet-dialog :isShowWalletDialog.sync="isShowWalletDialog" :money="money"/>
    <adjust-dialog :isShowAdjustDialog.sync="isShowAdjustDialog" @adjustBalanceSuccess="onSearch"/>
    <import-file 
      :isShowImportDialog.sync="isShowImportDialog" 
      reportName="importWalletAdjust"
      :downloadConfig="{
        downloadName: 'importCustomerWalletAdjust',
        name: '调账记录模版'
      }"
    />
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import transferPop from './transfer-pop'
import walletDialog from './componets/wallet-dialog'
import adjustDialog from './componets/adjust-dialog'
import importFile from "./componets/import-file.vue";
export default {
  name: "walletList",
  mixins: [tableMixin,pagePathMixin],
  components: {
    transferPop,
    walletDialog,
    adjustDialog,
    importFile
  },
  data() {
    return {
      searchForm: {
        orgName:'',
        cusName:'',
        storeName: "",
        staffName: "",
        userName: "",
        userPhone: "",
        status: "",
        activityName: "",
        activityId: "",
        updatedTime: [],
        walletType: '',
        mchNo: "",
      },
      businessStatus: [ 
        {value: '', label: '全部'},
        {value: 1, label: '正常营业'},
        {value: 2, label: '预停业'},
        {value: 3, label: '已停业'},
        {value: 4, label: '预营业'},
        {value: 5, label: '未开业停用'},
        {value: 6, label: '经营异常'},
      ],
      userStatus: [
        {value: '', label: '全部'},
        {value: 0, label: '在职'},
        {value: 1, label: '离职'},
      ],
      walletTypeStatus: [
        {value: '', label: '全部'},
        {value: 1, label: '老钱包'},
        {value: 8, label: '新钱包'},
        // {value: 9, label: '银联钱包'},
      ],
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
      isTransferPop: false,
      isShowWalletDialog: false,
      money: 0,
      isShowAdjustDialog: false,
      isShowImportDialog: false,
    };
  },
  methods: {
    init() {
      this.getList();
      this.getOrgBoardInfo();
    },
    getOrgBoardInfo() {
      this.$api.dataReport.orgBoardInfo().then((res) => {
        this.panelData = res.data;
      });
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .customerWalletPcPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === "updatedTime" && val) {
          this.filterParam.startTime = val[0] || "";
          this.filterParam.endTime = val[1] || "";
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;

      if (actionType == 3) {
        this.openSubPage({
          name: "manageList",
          params: row,
        });
      } else if (actionType == 1) {
        let params = {
          ...this.filterParam,
        };
        this.$api.common.doExport("customerWalletPageList", params).then(() => {
          this.$message.success("导出操作成功，请前往导出记录查看详情");
        });
      }
    },
    jumpTransferRecord() {
      this.openSubPage({
        path: '/dataReport/transfer-record'
      })
    },
    jumpAdjustRecord() {
      this.openSubPage({
        path: '/dataReport/adjust-record'
      })
    },
    look(row) {
      this.$api.dataReport.customerUnionWalletDetail(row.customerId)
        .then(res => {
          if (res.success) {
            this.money = res.data.frozenMarginAmount
            this.isShowWalletDialog = true
          }
        })
    }
  },
  mounted() {
    this.init();
  },
  filters: {
    businessStatus(value) {
      let map = {
        1:'正常营业',
        2:'预停业',
        3:'已停业',
        4:'预营业',
        5:'未开业停用',
        6:'经营异常'
      }
      return map[value]
    },
    walletType(value) {
      return value == 1 ? '老钱包' : '新钱包'
    }
  }
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}
.el-icon-question {
  margin-left: 2px;
  font-size: 16px;
}

</style>
